import TimeTypeConfig from '../TimeConfig.type';

export default {
  ...TimeTypeConfig,
  name: 'foliage.time',
  contributorRoles: ['admin', 'contributor', 'user', 'company'],
  constraints: [],
  renderName: (): string => 'features.foliage.time.'
};
